/**
 * Intro Loon Hero — front-end behaviour.
 *
 * The hero photo parallax drift is delegated to the shared parallax component,
 * which honors prefers-reduced-motion (leaving the static CSS scale headroom in
 * place) and gates its scroll math behind an IntersectionObserver. The block
 * opts in via the `has-parallax` class and the `data-parallax-speed` attribute,
 * both emitted by save.js. The headline letters animate in via the shared
 * letters-reveal component (honors prefers-reduced-motion).
 *
 * @see src/js/front/components/parallax.js
 */
import { initImageParallax } from '../../js/front/components/parallax';
import { initLettersReveal } from '../../js/front/letters-reveal';

document
	.querySelectorAll( '.b-intro-loon-hero.has-parallax' )
	.forEach( ( block ) =>
		initImageParallax( block, { imageSelector: '.b-intro-loon-hero__image' } ),
	);

// Headline letters drop in (moving-letters #16) on first view; the editor's
// loop toggle keeps replaying it. A block without a headline is a no-op.
document.querySelectorAll( '.b-intro-loon-hero' ).forEach( ( block ) =>
	initLettersReveal( block.querySelector( '.b-intro-loon-hero__title' ), {
		wrapWords: true,
		loop: block.classList.contains( 'has-title-loop' ),
	} ),
);
